import React, {useMemo, createContext, useCallback, useContext, useState} from 'react';
import { CountContext, CartContext } from "./MyContext";
//ToDO: расширить объект заказа продукта добавив размер и тип. сделать отображение в корзине типа.
//FixMe: добавление одного товара многократно, неправельное формировние суммы
function CartProvider({ children }) {
    const [counter, setCounter] = useState(0);
    const [priceAmount, setPriceAmount] = useState(0);
    const [itemCount, setItemCount] = useState(0)
    const [emptyCart, setEmptyCart] = useState(true)

    let cartData = useContext(CartContext);


    // Define a callback function
    const handleButtonClick = useCallback((id, price ,title, imageUrl, activeSize, activeType) => {
        // Function logic

        // Сreates a clicked object
        const objData = {
            id: id, price: price, amount: price, title: title, imageUrl: imageUrl, count: 1, size: activeSize,
        }

        // Function checking for the availability of such an object
        // if such an object exists, the quantity and price is increased by one.
        // Otherwise, the object is added to the storage for the shopping cart
        const createData = (obj) =>{
            if(cartData.some(o => o.id === obj.id) && cartData.some(o => o.size === obj.size)){
               const index = cartData.findIndex(o => o.id === obj.id)
                cartData[index].count += 1;
                cartData[index].amount += obj.price;
                console.log('hasData' + index)
            } else {
                cartData.push(obj)
            }
        };
        setEmptyCart(true)
        console.log(createData(objData));


        setCounter(counter + 1)
        setPriceAmount( priceAmount + price )
        setItemCount(cartData.length)
        console.log('addCount: ' + counter)
        console.log(priceAmount)
        console.log(cartData)
        console.log("type: " + activeType);
        console.log("size: " + activeSize);

    }, [counter, priceAmount, itemCount]);
    // Memoize the context provider with the callback
    const contextValue = useMemo(() => ({
        priceAmount,
        setPriceAmount,
        counter,
        setCounter,
        setItemCount,
        emptyCart,
        setEmptyCart,
        itemCount,
        handleButtonClick,
    }), [counter, priceAmount, itemCount]);
    return (
        <CountContext.Provider value={contextValue}>
            {children}
        </CountContext.Provider>
    );
}
export default CartProvider;